export { StructuredData } from './components';

export type { StructuredDataProps, StructuredDataType } from './components';
